import {Edge} from 'reactflow';

import getLoopIgnoringAncestorsAndEdges from 'util/graph-utils/getLoopIgnoringAncestorsAndEdges';
import {AdjacencyMap} from 'util/graph-utils/GraphUtilConstants';

/**
 * Checks whether an edge is a looping back edge, where a back edge is defined as follows:
 * An edge B -> A is a back edge if A is an ancestor of B in the DFS tree.
 */
export function backEdgeExists(
  fromNodeClientId: string,
  toNodeClientId: string,
  edges: Array<Edge>,
  rootNodeClientId: string
): boolean {
  const adjacencyMap: AdjacencyMap = {};
  for (const {source, target} of edges) {
    if (adjacencyMap[source] == null) {
      adjacencyMap[source] = [];
    }
    adjacencyMap[source].push(target);
  }
  const {nodeIdsToAncestors} = getLoopIgnoringAncestorsAndEdges(rootNodeClientId, adjacencyMap);
  return (
    nodeIdsToAncestors[fromNodeClientId] != null && nodeIdsToAncestors[fromNodeClientId].has(toNodeClientId)
  );
}
